/**
 * patrol-arrests-bites-edit.js
 */

import React from 'react';
import { 
  useMediaQuery,
  Grid, 
  Typography, 
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useFormContext, useWatch } from 'react-hook-form';
import { Types } from 'utils/constants';
import ArrestsEdit from './arrests-edit';
import FormGridContainer from 'components/menu-drawer/form-grid-container';
import FormGridItem from 'components/menu-drawer/form-grid-item';
import FormSectionTitle from 'components/menu-drawer/form-section-title';
import HelpTextItem from 'components/menu-drawer/help-text-item';
import { EditorIconSection } from 'components/icon-section/icon-section';
import TextField from 'components/form-inputs/text-field';


export default function PatrolArrestsBitesEdit(props) {
  const { 
    drawerState,
    patrolIndex,
    edit,
    isAdd
  } = props;
  const { t } = useTranslation(edit.translation);
  const { t: tGen } = useTranslation('general');
  const isMobile = useMediaQuery(theme => theme.breakpoints.down('sm'), { noSsr: true });
  const formBaseName = `patrol.patrolTypes[${patrolIndex}]`;
  const { trigger } = useFormContext();
  const patrolRecord = useWatch({ name: formBaseName });


  return (
    <>
      <EditorIconSection
        iconName='patrol-arrests-bites'
        iconMarginTop={0}
        helpProps={{
          translation: edit.translation,
          section: 'arrests-bites'
        }}
        data-testid='people-found-or-arrested'
      >
        <HelpTextItem
          sidebarText={drawerState.sidebarText}
          title={t('arrests-bites.arrests-bites.helpTitle')}
          text={t('arrests-bites.arrests-bites.helpInfo')}
        >
          {focusHandlers =>
            <>
              <FormSectionTitle style={{ marginBottom: 16 }}>
                {t(isMobile ? 'arrests-bites.arrests-bites.label' : 'arrests-bites.sectionName')}
              </FormSectionTitle>

              <FormGridContainer>

                <Grid item xs={12}>
                  <Typography variant='subtext-small'>
                    {t('arrests-bites.arrests-bites.helpInfoClarifier', { patrolTypeTitle: tGen(patrolRecord ? `types.patrol.${patrolRecord?.type}` : '') })}
                  </Typography>
                </Grid>

                {/* people found */}
                <FormGridItem>
                  <TextField
                    name={`${formBaseName}.peopleFoundCount`}
                    label={t('arrests-bites.peopleFound.label')}
                    defaultValue={isAdd ? 0 : undefined}
                    type="number"
                    focusHandlers={focusHandlers}
                    onChange={() => trigger([`${formBaseName}.peopleUnintentionallyBittenCount`])}
                    rules={{
                      required: t('arrests-bites.arrests-bites.errMsgEmpty'),
                      max: {
                        value: 999999999,
                        message: t('arrests-bites.arrests-bites.errMsgSize')
                      },
                      min: {
                        value: patrolRecord?.arrests?.length,
                        message: t('arrests-bites.peopleFound.errMsgGreaterThanArrests', { countArrests: patrolRecord?.arrests?.length }),
                      },
                    }}
                  />
                </FormGridItem>

                {/* unintentional bites */}
                <FormGridItem>
                  <TextField
                    name={`${formBaseName}.peopleUnintentionallyBittenCount`}
                    label={t('arrests-bites.peopleUnintentionallyBitten.label')}
                    defaultValue={isAdd ? 0 : undefined}
                    type="number"
                    focusHandlers={focusHandlers}
                    rules={{
                      required: t('arrests-bites.arrests-bites.errMsgEmpty'),
                      max: {
                        value: 999999999,
                        message: t('arrests-bites.arrests-bites.errMsgSize')
                      },
                    }}
                  />
                </FormGridItem>

              </FormGridContainer>
            </>}
        </HelpTextItem>

        {/* Arrest Data Items */}
        <ArrestsEdit
          {...props}
          formParentDataName={formBaseName}
          workMode={Types.WorkMode.PATROL}
        />
      </EditorIconSection>
    </>
  );
}